export function createRoutes() {
  return [
    {
      path: 'taxonomy',
      component: () => import(
        /* webpackChunkName: "TaxonomyChrome" */ './TaxonomyChrome.vue'
      ),
      children: [
        {
          path: '/',
          component: () => import(
            /* webpackChunkName: "TaxonomyList" */ './TaxonomyList.vue'
          ),
        },
        {
          path: 'create',
          name: 'createTaxonomy',
          components: {
            default: () => import(
              /* webpackChunkName: "TaxonomyList" */ './TaxonomyList.vue'
            ),
            createTaxonomy: () => import(
              /* webpackChunkName: "TaxonomyModal" */ './TaxonomyModal.vue'
            ),
          },
        },
        {
          path: ':tagKey/edit',
          name: 'editTaxonomy',
          components: {
            default: () => import(
              /* webpackChunkName: "TaxonomyList" */ './TaxonomyList.vue'
            ),
            editTaxonomy: () => import(
              /* webpackChunkName: "TaxonomyModal" */ './TaxonomyModal.vue'
            ),
          },
        },
        {
          path: ':tagKey',
          component: () => import(
            /* webpackChunkName: "TaxonomyChrome" */ './TaxonomyTagChrome.vue'
          ),
          children: [
            {
              path: '/',
              name: 'TaxonomyList',
              component: () => import(
                /* webpackChunkName: "TaxonomyList" */ './TaxonomyTagList.vue'
              ),
            },
            {
              path: 'create',
              name: 'createTag',
              components: {
                default: () => import(
                  /* webpackChunkName: "TaxonomyTagList" */ './TaxonomyTagList.vue'
                ),
                createTag: () => import(
                  /* webpackChunkName: "TagModal" */ './TagModal.vue'
                ),
              },
            },
            {
              path: ':id/edit',
              name: 'editTag',
              components: {
                default: () => import(
                  /* webpackChunkName: "TaxonomyTagList" */ './TaxonomyTagList.vue'
                ),
                editTag: () => import(
                  /* webpackChunkName: "TagModal" */ './TagModal.vue'
                ),
              },
            },
          ],
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
